import React, { useEffect } from "react";

import DataTable from "../../DataTable/index";
import Loading from "../../Loading";
import { useReserves } from "../Hooks";
import ReserveItem from "../../../../../App/Panel/components/reserveItem";
import { Day, ToTimeJalali } from "../../../Function";
import { ToDateJalali } from "../../../../../Web/Common/Function";
const TimeReservesList = ({ isApp }) => {
  const { getResrves, data, loading, renderTime, paginate } = useReserves();
  useEffect(() => {
    getResrves();
  }, []);

  const checkStats = (data) => {
    switch (data) {
      case "active":
        return { text: "فعال", color: "#1BA462" }
      case "waittopay":
        return { text: "در انتظار پرداخت", color: "#F5BC1A" }
      case "canceled":
        return { text: "کنسل شده", color: "#E42A3F" }
      case "payerror":
        return { text: "ناموفق", color: "#E42A3F" }
      case "used":
        return { text: "منقضی شده", color: "#F5BC1A" }
    }
  }

  const checkDate = (data) => {
    return { date: ToTimeJalali(data).split('-')[0], dayname: '', time: ToTimeJalali(data).split('-')[1] }
  }

  const checkReserveTime = (data) => {
    return {
      date: ToDateJalali(data.date),
      dayname: Day(data.dayname),
      time: data.start + " تا " + data.end
    }
  }

  if (loading.list) {
    return <Loading count={1} col={12} height="400px" />;
  }

  return (
    <div>

      {isApp &&
        <div className="my-3">
          {data.data.map(item => (
            <ReserveItem
              statusColor={checkStats(item.status).color}
              statusText={checkStats(item.status).text}
              r1={item.fullname} r2={item.mobile} r3={`کد پیگیری : ${item?.trackingcodeorder} `}
              l1={item.created_at ? checkDate(item.created_at).dayname : checkReserveTime(item.reserve_time).dayname}
              l2={item.created_at ? checkDate(item.created_at).date : checkReserveTime(item.reserve_time).date}
              l3={item.created_at ? checkDate(item.created_at).time : checkReserveTime(item.reserve_time).time} />
          ))}
        </div>
      }

      {!isApp &&
        <DataTable
          data={data}
          list={data.data}
          heads={[
            {
              title: "نام ",
              key: "fullname",
            },
            {
              title: "شماره ",
              key: "mobile",
            },
            {
              title: "کدملی ",
              key: "national_code",
            },
            {
              title: "وضعیت",
              key: "status",
              type: "enum",
              enum: {
                active: "فعال",
                canceled: "کنسل شده",
                waittopay: "خطا در پرداخت",
                payerror: "خطا در پرداخت",
                used: "منقضی شده",
              },
            },
          ]}
          function={paginate}
          header={renderTime()}
        // search={ }
        />
      }
    </div>
  );
};

export default TimeReservesList;
